/**
 * Skeleton Loaders - Componentes de carga optimizados para móvil
 * Reemplazan los mensajes "Cargando..." con placeholders visuales
 */

// Skeleton para lista de fichajes
export const SkeletonFichajes = ({ count = 3 }) => {
  return (
    <div className="space-y-4">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="card-elevated">
          <div className="flex items-center justify-between">
            <div className="flex-1 space-y-3">
              <div className="skeleton-text w-3/4"></div>
              <div className="skeleton-text w-1/2"></div>
            </div>
            <div className="skeleton-circle h-12 w-12"></div>
          </div>
        </div>
      ))}
    </div>
  )
}

// Skeleton para cards de estadísticas
export const SkeletonStats = ({ count = 4 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="card-elevated">
          <div className="space-y-3">
            <div className="skeleton-text w-1/2"></div>
            <div className="skeleton-text h-8 w-3/4"></div>
          </div>
        </div>
      ))}
    </div>
  )
}

// Skeleton para tabla
export const SkeletonTable = ({ rows = 5 }) => {
  return (
    <div className="space-y-2">
      {/* Header */}
      <div className="flex gap-4 p-4 bg-gray-50 rounded-lg">
        <div className="skeleton-text w-1/4 h-5"></div>
        <div className="skeleton-text w-1/4 h-5"></div>
        <div className="skeleton-text w-1/4 h-5"></div>
        <div className="skeleton-text w-1/4 h-5"></div>
      </div>

      {/* Rows */}
      {[...Array(rows)].map((_, index) => (
        <div key={index} className="flex gap-4 p-4 bg-white rounded-lg border">
          <div className="skeleton-text w-1/4"></div>
          <div className="skeleton-text w-1/4"></div>
          <div className="skeleton-text w-1/4"></div>
          <div className="skeleton-text w-1/4"></div>
        </div>
      ))}
    </div>
  )
}

// Skeleton para perfil/info de empleado
export const SkeletonProfile = () => {
  return (
    <div className="card-elevated">
      <div className="flex items-start gap-4">
        <div className="skeleton-circle h-16 w-16"></div>
        <div className="flex-1 space-y-3">
          <div className="skeleton-text w-1/2 h-6"></div>
          <div className="skeleton-text w-3/4"></div>
          <div className="skeleton-text w-2/3"></div>
        </div>
      </div>
    </div>
  )
}

// Skeleton para reloj de fichaje (página principal)
export const SkeletonClock = () => {
  return (
    <div className="card-glass">
      <div className="flex flex-col items-center space-y-6 p-8">
        <div className="skeleton-circle h-48 w-48 sm:h-64 sm:w-64"></div>
        <div className="space-y-3 w-full max-w-md">
          <div className="skeleton-text h-8 w-3/4 mx-auto"></div>
          <div className="skeleton-text w-1/2 mx-auto"></div>
        </div>
        <div className="flex gap-4 w-full max-w-md">
          <div className="skeleton h-14 flex-1 rounded-xl"></div>
          <div className="skeleton h-14 flex-1 rounded-xl"></div>
        </div>
      </div>
    </div>
  )
}

// Skeleton genérico
export const SkeletonCard = ({ height = 'h-24' }) => {
  return <div className={`skeleton-card ${height}`}></div>
}

export default {
  SkeletonFichajes,
  SkeletonStats,
  SkeletonTable,
  SkeletonProfile,
  SkeletonClock,
  SkeletonCard
}
